import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
  selector: '[sharedTableColumn]',
  standalone: true
})
export class TableColumnDirective {
  @Input({required: true}) sharedTableColumn!: string

  constructor(public templateRef: TemplateRef<any>) { }

}
